import React from "react";
import { Link } from "react-router-dom";
import PropTypes from "proptypes";

import closeIcon from "./../../../../src/assets/sidebar-x-icon.png";
import "./Sidebar.scss";

const base = "https://www.givevolunteers.org/";

const Sidebar = ({ isToggled, toggleSideBar, onLogout }) => (
  <div className={`sidebar clickable ${isToggled ? "active" : ""}`}>
    <p>
      <button
        className="small"
        onClick={toggleSideBar}
        onKeyPress={toggleSideBar}
      >
        <img className="close-sb" src={closeIcon} alt="close icon" />
        &nbsp;&nbsp;Close
      </button>
    </p>
    <button className="btn-plain-text" onClick={toggleSideBar}>
      <a href="/portal-home" id="home">
        <h6>Volunteer Profile</h6>
      </a>
    </button>
    {window.localStorage.sessionToken ? (
      <ul>
        <li>
          <Link to="/portal-home#top" onClick={toggleSideBar}>My Trips</Link>
        </li>
        <li>
          <Link to="/portal-home#add-ons" onClick={toggleSideBar}>Extend Your Trip</Link>
        </li>
        <li>
          <Link to="/trip-selection" onClick={toggleSideBar}>Select a Trip</Link>
        </li>
        <li>
          <Link to="/profile#past-trips" onClick={toggleSideBar}>See Trip History</Link>
        </li>
        <li>
          <Link to="/portal-home#invite-friends" onClick={toggleSideBar}>Invite Friends to Join</Link>
        </li>
        <li>
          <Link to="/profile#top" onClick={toggleSideBar}>My Profile</Link>
        </li>
        <li>
          <a
            href="#logout"
            onClick={(e) => {
              e.preventDefault();
              onLogout();
              toggleSideBar();
            }}
          >
            Logout
          </a>
        </li>
      </ul>
      ) : (
      <ul>
        <li>
          <Link to="/" onClick={toggleSideBar}>Login</Link>
        </li>
        <li>
          <Link to="/sign-up" onClick={toggleSideBar}>Apply</Link>
        </li>
      </ul>
    )}
    <h6>Give Website</h6>
    <ul>
      <li>
        <a
          href={`${base}`}
          rel="noopener noreferrer"
          target="_blank"
        >
          Home Page
        </a>
      </li>
      <li>
        <a
          href={`${base}contact/`}
          rel="noopener noreferrer"
          target="_blank"
        >
          Contact Us
        </a>
      </li>
    </ul>
  </div>
);

Sidebar.propTypes = {
  isToggled: PropTypes.bool.isRequired,
  toggleSideBar: PropTypes.func.isRequired,
  onLogout: PropTypes.func.isRequired
};

export default Sidebar;
